import layout1 from './layout/LayoutConfig';

const themeLayoutConfigs = {
  layout1,
};

export default themeLayoutConfigs;
